import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import withProvider from '../../../gql/withProvider.js';
import SignUpFormContainer from './SignUpFormContainer.js';

const mapStateToProps = (state) => {
    return {
        signInFailed: state.signInForm.validationError,
    };
};

export default flowRight(
    connect(mapStateToProps),
    withProvider,
    withCustomMetrics({
        category: 'Booking - Sign Up',
        page: 'Booking',
        section: 'Sign Up View',
    })
)(SignUpFormContainer);
